import { render } from "./DetailedProjectOverview.vue?vue&type=template&id=f7ad4284&scoped=true"
import script from "./DetailedProjectOverview.vue?vue&type=script&lang=js"
export * from "./DetailedProjectOverview.vue?vue&type=script&lang=js"

import "./DetailedProjectOverview.vue?vue&type=style&index=0&id=f7ad4284&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7ad4284"]])

export default __exports__